import hcap from "./hcap"
import universal from "./universal"
import playmore from "./playmore"
import tizen from "./tizen"
import tizenv2 from "./tizenv2"
import philips from "./philips"
import wixp from "./wixp"
import wixpv2 from "./wixpv2"
import samsung from "./samsung"
import playmoreatv from "./playmoreatv"

class Bridges {
  constructor() {
    this.hcap = hcap
    this.universal = universal
    this.playmore = playmore
    this.tizen = tizen
    this.tizenv2 = tizenv2
    this.philips = philips
    this.wixp = wixp
    this.wixpv2 = wixpv2
    this.samsung = samsung
    this.playmoreatv = playmoreatv
  }
}

export default new Bridges()
